export default "__VITE_ASSET__CxaArUT9__"